import styles from './styles.js';

const Detail = ({ description, value, extra, classes }) => (
  <div className={classes.detail}>
    <div className={classes.detailDescription}>{description}</div>
    <div className={classes.detailValue}>{value}</div>
    <div className={classes.detailExtra}>{extra}</div>
  </div>
);

Detail.propTypes = {
  description: PropTypes.string,
  value: PropTypes.string,
  extra: PropTypes.string,
};

export default withStyles(styles)(Detail);
